import Cookies from 'js-cookie'
import config from './config';
import md5 from 'js-md5';
import CryptoJS from 'crypto-js'

// 获取token
export function 
getToken() {
  return Cookies.get(config.tokenKey)
}

// 设置token
export function setToken(token) {
  return Cookies.set(config.tokenKey, token, { path: '/', domain: '.aeroiot.cn' })
}

// 移除token
export function removeToken() { 
  return Cookies.remove(config.tokenKey, { path: '/', domain: '.aeroiot.cn' })
}


export function getTicket(){
  var token = getToken();
  if(!token){
    return null;
  }

  return Cookies.get("online_ticket");

  // // 加密token处理, 还未调通 TODO
  // if(token.indexOf(".")<0){
  //   token = token.replace(/\n*$/g, '').replace(/\n/g, '');
  //   // console.log(token);
  //   // // AES解密前转义处理
  //   // // var temp = CryptoJS.enc.Base64.parse(token);
  //   // // console.log(temp);
  //   // var decTemp = CryptoJS.AES.encrypt(token, cofnig.appSecret, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
  //   // token = decTemp.toString(CryptoJS.enc.Utf8);
  //   // console.log(token);
  //   token = decrypt(token);
  // }
  // let tokenArray = token.split(".");
  // if(tokenArray.length<2){
  //   return null;
  // }
  // let tokenCore = tokenArray[1];
  // var newCore = tokenCore.replace("-","+").replace("_","/")
  // var userInfo = JSON.parse(decodeURIComponent(escape(window.atob(newCore))));
  // return userInfo.online_ticket;
}

// export function loadUserInfo(){
//   var userInfoApi = store.state.apis.userinfo;
//   axios.get(userInfoApi).then(
//       response => {
//           if (response.status === 200 && response.data) {    
//               var result = response.data;
//               if(result.code === 200){
//                 return result.data;    
//               }else{
//                 console.log('用户查询失败:' + result.message);
//                 return {};
//               }                                  
//           }
//           else{
//               console.log('用户查询失败:' + response.message);
//               return {};
//           } 
//       },
//       error => {
//         debugger;
//         console.log('用户详情接口调用失败:' + error.message);
//         return {};
//       }
//   );
// }

//加密
  function encrypt(word){ 
    var keyStr = keyStr ? keyStr : config.appSecret;
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return encrypted.toString();
  }
   
  //解密
  function decrypt(word){  
    var keyStr = keyStr ? keyStr : config.appSecret;
    var key  = CryptoJS.enc.Utf8.parse(keyStr);
    var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
  }

  // JS`正则表达式`获取地址栏url参数：
  export function getUrlParam(name) {
    var splits = window.location.href.split('?');
    if(splits.length > 1){
      let queries = splits[1].split("&");
      // console.log(url)
      let paramObj = new Object()
      queries.forEach((item, i) => {
        paramObj[item.split('=')[0]] = item.split('=')[1]
      })
      return paramObj[name];
    }
    return null;      
  }

    // 写cookie
  export function setCookie(key, value) {
      return Cookies.set(key,value, { path: '/', domain: '.aeroiot.cn' });
  }


  // 设置token
  export function getCookie(name) {
    return Cookies.get(name);
  }

  // 移除token
  export function removeCookie(name) { 
    return Cookies.remove(name, { path: '/', domain: '.aeroiot.cn' })
  }


// WEBPACK FOOTER //
// ./src/utils/auth.js